<template>
  <div class="Cinema-detail bg-round bg-fff" v-if="detail">
    <div class="container" id="w-1200px">
      <Bread :list="breadList" class="ma-t-10" />
      <div class="flex f-between ma-t-30">
        <div class="bg-000 flex f-center f-jcenter" style="width:77%;height: 700px; ">
          <video :src="detail.MovieUrl" class="bg-000 img_contain height100 width100"  controls :poster="detail.Image" @play="videoPlay()"></video>
        </div>
        <div class="width20">
          <div class="pa-tb-10 font-bold fon-22">{{ detail.Name }}</div>
          <div class="c-666">{{ detail.Areas }}、{{ detail.Category }}、{{ detail.Age }}</div>
          <div class="font-bold ma-t-20">导演</div>
          <div class="c-666 ma-t-10">{{ detail.Direct }}</div>
          <div class="font-bold ma-t-20">主演</div>
          <div class="c-666 ma-t-10">{{ detail.Actor }}</div>
          <div class="font-bold ma-t-20">介绍</div>
          <div class="c-666 ma-t-10">
            {{ detail.Summary }}
          </div>
          <div class="ma-t-40">
            <div class="btn-buy c-p" @click="addOrder" v-if="!detail.IsPay&&detail.Price>0"> ￥{{ detail.Price }}</div>
            <div class="btn-buy c-p" v-else-if="detail.Price==0"> 免费观看</div>
            <div class="btn-buy c-p" v-else>您已购买</div>
          </div>
        </div>
      </div>
      <div class="menu-item fon-24 ma-t-70">
        <div class="font-bold">为你推荐</div>
        <div class="font-bold">Recommended for you</div>
        <img
          src="../img/index/index21.png"
          class="item-right width90"
          alt=""
          srcset=""
        />
        <img
          src="../img/index/index22.png"
          class="item-left"
          alt=""
          srcset=""
        />
      </div>
      <div class="flex f-wrap ma-t-30">
        <div
          class="box-item ma-b-40 t-center"
          v-for="(item, index) in detail.Similar"
          :key="index"
          @click="$router.replace({path:'/movie/detail',query:{id:item.Id}})"
        >
          <img
            :src="item.Image"
            width="100%"
            height="80%"
            class="img_cover b-r-15"
            alt=""
            srcset=""
          />
          <div class="ma-t-20">{{ item.Name }}</div>
          <div class="ma-t-10">{{ item.Title }}</div>
        </div>
      </div>

      <div class="menu-item fon-24 ma-t-70">
        <div class="font-bold">详细介绍</div>
        <div class="font-bold">Detailed introduction</div>
        <img
          src="../img/index/index21.png"
          class="item-right width90"
          alt=""
          srcset=""
        />
        <img
          src="../img/index/index22.png"
          class="item-left"
          alt=""
          srcset=""
        />
      </div>
      <div class="ma-t-30 lh-html" v-html="detail.Content"></div>
    </div>

    <!-- 扫码弹框 -->
    <div class="qrcode-popup" v-show="isQrcodePopup" @click="closePopup">
      <div class="popup-main" v-cloak>
        <div class="t-center" v-show="!isPayResult">
          <div class="bold">
            支付金额：<span class="fon-20 c-red">{{ detail.Price }}元</span>
          </div>
          <div id="qrcode" class="ma-tb-20"></div>
          <div class="mt-10">微信扫码支付</div>
        </div>
        <div class="t-center" v-show="isPayResult">
          <h2 class="bold">支付成功</h2>
          <div>
            <i class="iconfont icon-chenggong icon-success"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var _this
import { getCinemaDetail, payAddCinema, orderPay, PayResult,AddPayCinema } from "../api.js";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      breadList: [
        {
          name: "翠麟云剧场",
          path: "/movie/index",
        }
      ],
      detail: null,
      id: null,
      isPayResult:false,//是否支付成功
      isQrcodePopup:false,//是否弹框
      payRep: {},
      tInterval1:null,
      isVideoPlay:false,//本次进入页面是否点击过播放，每次进入页面初始化为false
    };
  },
  created() {
    _this=this
    _this.id = this.$route.query.id;
    this.loadData();
  },
  methods: {
    loadData() {
      getCinemaDetail({ id: this.id }).then((res) => {
        this.detail = res.data.Data;
        this.breadList.push({
          name:res.data.Data.Name,
          path:''
        })
      });
    },
    //下单
    addOrder() {
      payAddCinema({
        MovieId: this.id,
      }).then((result) => {
        orderPay({
          Key: result.data.Data.Key,
          Type: "weixin",
        }).then((res) => {
          this.isQrcodePopup = true;
          this.payRep = res.data.Data;
          new QRCode(document.getElementById("qrcode"), res.data.Data.Qrcode);

          //循环获取扫码支付结果
          this.tInterval1 = setInterval(() => {
            if (this.isPayResult) {
              clearInterval(this.tInterval1);
            } else {
              this.isPaySuccess();
            }
          }, 1500);
        });
      });
    },
    //是否支付成功，循环请求
    isPaySuccess() {
      PayResult({ PayId: this.payRep.PayId }).then((res) => {
        this.isPayResult = res.data.Data;
        if (this.isPayResult) {
          setTimeout(() => {
            this.isQrcodePopup = false;
            this.loadData();
          }, 1500);
        }
      });
    },
    //关闭弹框
    closePopup(){
      this.isQrcodePopup=false
      document.getElementById('qrcode').innerHTML=''
    },
    //视频点击播放，新增播放记录
    videoPlay(){
      if(!this.isVideoPlay){
        this.isVideoPlay=true
        AddPayCinema({Id:this.id})
      }
    }
  },
  watch:{
    '$route.query.id'(val){
      if(val){
        this.id= this.$route.query.id
        this.isVideoPlay=false
        this.loadData()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 1150px;
  // background: #ffffff;
  box-sizing: border-box;
  padding: 30px 40px;
}
.btn-buy {
  width: 238px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background: #f9014b;
  border-radius: 25px;
  color: #fff;
}
.menu-item {
  position: relative;
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
  }
  .item-left {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.box-item {
  width: 18%;
  height: 320px;
}
.box-item:not(:nth-child(5n)) {
  margin-right: calc(10% / 5);
}

.qrcode-popup {
        background-color: rgba(0, 0, 0, 0.571);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .qrcode-popup .popup-main {
        background-color: #fff;
        padding: 50px;
        border-radius: 5px;

    }
</style>